import React from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import AssignmentIcon from '@material-ui/icons/Assignment';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import DraftsIcon from '@material-ui/icons/Drafts';
import FolderShared from '@material-ui/icons/FolderShared';
import SendIcon from '@material-ui/icons/Send';
import Schedule from '@material-ui/icons/Schedule';
import AttachMoney from '@material-ui/icons/AttachMoney';
import Dashboard from '@material-ui/icons/Dashboard';
import { Link } from 'react-router-dom';

export const mailFolderListItems = (
  <div>
    <Link to="/dashboard">
      <ListItem button>
        <ListItemIcon>
          <Dashboard />
        </ListItemIcon>
        <ListItemText primary="Dashboard" />
      </ListItem>
    </Link>
    <Link to="/leads">
      <ListItem button>
        <ListItemIcon>
          <AssignmentIndIcon />
        </ListItemIcon>
        <ListItemText primary="Leads" />
      </ListItem>
    </Link>
    <Link to="/applications">
      <ListItem button>
        <ListItemIcon>
          <AssignmentIcon />
        </ListItemIcon>
        <ListItemText primary="Applications" />
      </ListItem>
    </Link>
    <Link to="/settlements">
      <ListItem button>
        <ListItemIcon>
          <AttachMoney />
        </ListItemIcon>
        <ListItemText primary="Settlements" />
      </ListItem>
    </Link>
  </div>
);



// WEBPACK FOOTER //
// ./src/containers/Admin/Sidebar/index.js